module.exports = __webpack_public_path__ + "static/media/full-screen.6dd14f74.svg";